document.body.addEventListener("click", function (e) {
  const submenuTrigger = e.target.closest('.header__inline-menu details');

  if (submenuTrigger) {
    e.preventDefault();

    const submenu = submenuTrigger.querySelector('[data-submenu-item]');


    if (!submenu) return;

    const drawer = document.querySelector('#SubMenuDrawer');
    const drawerContent = drawer.querySelector('.submenu-drawer-body');

    drawerContent.innerHTML = submenu.innerHTML;
    
    drawer.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('submenu-drawer-open');
    document.querySelector(".menu-drawer-overlay")?.classList.add("is-open");
    return;
  }

  // close on close-icon click
  if (e.target.closest('#SubMenuDrawer .submenu-drawer-close')) {
    closeSubMenuDrawer();
    return;
  }

  // close on overlay click
  if (e.target.closest('.menu-drawer-overlay')) {
    closeSubMenuDrawer();
  }

  if(e.target.closest('.fillter_close_icon')){
    document.querySelector('.mobile-facets__close').click();
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') closeSubMenuDrawer();
});

function closeSubMenuDrawer() {
  const drawer = document.querySelector('#SubMenuDrawer');
  const overlay = document.querySelector(".menu-drawer-overlay");

  // Start close animation
  drawer.classList.remove('is-open');
  overlay?.classList.remove("is-open");

  // Wait until animation finishes
  setTimeout(() => {
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('submenu-drawer-open');
    document.body.classList.remove('drawer-open');
  }, 550); // Match CSS transition duration (.45s)
}


// accordions js start
document.addEventListener("click", function (e) {
	const accordion = e.target.closest("[data-accordion-title]");
	if (!accordion) return;

	e.stopPropagation();

	const isActive = accordion.classList.contains("active");
	const group = accordion.closest("[data-accordion]");
	if (!group) return;

	// Close direct siblings in the same group
	group.querySelectorAll(":scope > [data-accordion-title]").forEach((item) => {
		item.classList.remove("active");
		if (item.nextElementSibling) {
			item.nextElementSibling.style.maxHeight = null;
		}
	});

	// Close all accordions inside the parent
	group.parentElement.querySelectorAll("[data-accordion-title]").forEach((item) => {
		item.classList.remove("active");
		if (item.nextElementSibling) {
			item.nextElementSibling.style.maxHeight = null;
		}
	});

	// Open clicked accordion
	if (!isActive) {
		accordion.classList.add("active");
		if (accordion.nextElementSibling) {
			accordion.nextElementSibling.style.maxHeight =
				accordion.nextElementSibling.scrollHeight + "px";
		}
	}
});


function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    console.log(accordion);
    const svg = accordion.querySelector('[js-acc-single-trigger] svg');
    svg.style.transform = 'rotate(0deg)';
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    
    if(intro){
      intro.onclick = (e) => { 
        if (content.style.maxHeight) {
          closeAccordion(accordion);
          const svg = intro.querySelector('svg');
          if (svg) {
            svg.style.transform = 'rotate(0deg)';
          }
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          const svg = intro.querySelector('svg');
          if (svg) {
            console.log(svg.parentElement.classList);
            if(svg.parentElement.classList.contains('footer-block__heading')){
              svg.style.transform = 'rotate(45deg)';
            }else{
              svg.style.transform = 'rotate(0deg)';
            }
          }
          openAccordion(e.target.closest('[js-acc-item]'));
        }
      };
    }
  });   
}

(function() { 
  faq_taggol(); 
})();

//faq section
// const faq_main_wap = document.querySelector('[faq_main_wap]') || null;
// if (faq_main_wap) {
//   const faq_toggles = faq_main_wap.querySelectorAll('[data-act-title]') || null;
//   const faq_content_wap = faq_main_wap.querySelector('[faq_content_wap]') || null;
//   const faq_content_tabs = faq_content_wap.querySelectorAll('.tabs') || null;
//   const faq_dropdown = faq_main_wap.querySelector('.faq-category-dropdown') || null;
//   const faq_selected = faq_main_wap.querySelector('.faq-category-selected') || null;
//   const mian_tag = document.querySelector('.faq-category')|| null;
//   const content = document.querySelector("[js-acc-single-content]");
  
//   if (faq_content_wap) {
//     faq_toggles.forEach((faq) => {
//       faq.addEventListener('click', (event) => {
//         faq_content_tabs.forEach((tab) => {
//           tab.classList.remove('active');
//           tab.style.display = 'none';
//         });

//         faq_toggles.forEach((toggle) => {
//           toggle.classList.remove('active-tab');
//         });

//         const targetSelector = event.currentTarget.getAttribute('data-act-title');
//         const targetTab = faq_content_wap.querySelector(targetSelector);

//         if (targetTab) {
//           targetTab.classList.add('active');
//           targetTab.style.display = 'block';
          
         
//         }
//         event.currentTarget.classList.add('active-tab');
        

//         if (faq_dropdown && faq_selected) {
//           faq_selected.textContent = event.currentTarget.textContent.trim();
//           faq_dropdown.classList.remove('open'); // Adjust class based on your dropdown open state
//           mian_tag.classList.remove('active');
//           if(content){
//             content.style.maxHeight = null;
//           }
//         }
//       });
//     });

//     if (faq_dropdown) {
//       faq_dropdown.addEventListener('click', () => {
//         faq_dropdown.classList.toggle('open'); // Add/remove "open" class for the dropdown
//       });
//     }
//   }
// }
//faq section end

// collection shortby filter dropdown
document.addEventListener("DOMContentLoaded", function () {
  const sort = document.querySelector("#CustomSort");
  if (!sort) return;

  const button = sort.querySelector(".custom-sort__toggle");
  const selected = sort.querySelector(".custom-sort__selected");

  button.addEventListener("click", function () {
    sort.classList.toggle("open");
  });

  document.addEventListener("click", function (e) {
    if (!sort.contains(e.target)) {
      sort.classList.remove("open");
    }
  });

  sort.querySelectorAll(".custom-sort__item").forEach(item => {
    item.addEventListener("click", function () {
      selected.textContent = this.textContent;
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", this.dataset.value);
      window.location.href = url.toString();
    });
  });

});


document.addEventListener('DOMContentLoaded', function () {

  const finder = document.querySelector('.custom-size-finder');

  if (!finder) return;

  const inputs = finder.querySelectorAll('.custom-size-finder__input');
  const bustInput = inputs[0];
  const waistInput = inputs[1];

  const unitSelect = finder.querySelector('.custom-size-finder__unit');
  const button = finder.querySelector('.custom-size-finder__button');

  const result = finder.querySelector('.custom-size-finder-result');
  const resultSize = finder.querySelector('.size-finder-result__size');
  const resultMessage = finder.querySelector('.size-finder-result__message');

  

  button.addEventListener('click', function (e) {

    e.preventDefault();
    console.log(999);
    let bust = parseFloat(bustInput.value);
    let waist = parseFloat(waistInput.value);

    if (!bust || !waist) {
      result.hidden = false;
      resultSize.textContent = '';
      resultMessage.textContent = 'Please enter your bust and waist measurements.';
      return;
    }

    /* Convert to inches */
    if (unitSelect.value === 'cm') {
      bust = bust / 2.54;
      waist = waist / 2.54;
    }

    if (unitSelect.value === 'metres') {
      bust = bust / 0.0254;
      waist = waist / 0.0254;
    }

    /*
      Find table from the OTHER section
    */
    const rows = document.querySelectorAll(
      '.size-chart-section .size-chart-table tbody tr'
    );

    let recommendedSize = '';
    let nextSize = '';

    for (let i = 0; i < rows.length; i++) {

      const cells = rows[i].querySelectorAll('td');

      if (cells.length < 3) continue;

      const size = cells[0].textContent.trim();

      const chartBust = parseFloat(
        cells[1].dataset.inches || cells[1].textContent
      );

      const chartWaist = parseFloat(
        cells[2].dataset.inches || cells[2].textContent
      );

      if (
        bust <= chartBust &&
        waist <= chartWaist
      ) {

        recommendedSize = size;

        if (rows[i + 1]) {
          const nextCells = rows[i + 1].querySelectorAll('td');

          if (nextCells.length) {
            nextSize = nextCells[0].textContent.trim();
          }
        }

        break;
      }
    }

    /* No matching size */
    if (!recommendedSize) {

      result.hidden = false;

      resultSize.textContent = '';

      resultMessage.textContent =
        'Your measurements are outside our available size range. Please contact us for help.';

      return;
    }

    /* Success message */

    result.hidden = false;

    resultSize.textContent = recommendedSize;

    if (nextSize) {

      resultMessage.innerHTML =
        'Based on your measurements, <strong>' +
        recommendedSize +
        '</strong> should fit perfectly. Prefer a roomier feel? Try <strong>' +
        nextSize +
        '</strong>.';

    } else {

      resultMessage.innerHTML =
        'Based on your measurements, <strong>' +
        recommendedSize +
        '</strong> should fit perfectly.';

    }

  });

});